export default class AuditService {
  constructor(auditLogger) {
    this.auditLogger = auditLogger;
  }

  getLogs(studentId) {
    return this.auditLogger.getLogs(studentId);
  }
}
